import { Link } from "react-router-dom";

const Transportation = () => {
    return (
      <div>
    
      <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pr-[2rem]  pt-[1rem]">
        <h1 className="text-[20px] font-bold">Students Logistics</h1>
       <p>
        Helping students who live away from their homes, caught up every now and then with their heavy 
        luggage which needs to be moved, such as computers, recreational items, documents and other personal 
        belongings. This cost-efficient service is designed to perfectly suit university, college, cadet 
        college and madrasa students relocating for studies, as well as educators and trainers temporarily moving away from home.
        </p>
        {/* <div className=" mt-[1rem]  max-w-[44rem] mx-auto mb-[100px]"> */}
                    
            <div className="flex justify-left mb-[100px] mt-[1rem]">
                <Link to="/pickup-request" className="flex justify-center text-center items-center h-9 mt-[2px]  text-white bg-[#D40511] border border-[#F21E26] w-[10rem] rounded-sm mt-[1rem]  h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">Quick Quote</Link>
                
            </div>
            </div>
  
       
      </div>
    // </div>
    );
  };
  
  export default Transportation;  